<template>
  <div class="container">
    <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left" v-model="tabactual" background-color="blue-grey lighten-4" horizontal v-if="cantidad>0">
      <v-tabs-slider></v-tabs-slider>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-tab v-on="on">
            <v-icon left>alarm</v-icon>PENDIENTES
          </v-tab>
        </template>
        <span>Corresponde a las tareas pendientes para indicadores PMI o planes nacionales</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-tab v-on="on">
            <v-icon left>assignment_turned_in</v-icon>HISTÓRICO
          </v-tab>
        </template>
        <span>Corresponde a fichas técnicas o registros de avance cuya gestión se encuentra finalizada</span>
      </v-tooltip>
      <v-tab-item>
        <v-stepper v-model="tipoproceso" editable non-linear class="mt-12 my-stepper">
          <template>
            Seleccione el instrumento de planeación para revisar las tareas pendientes
            <v-stepper-header>
              <v-row>
                <v-col cols="4"></v-col>
                <template v-for="n in cantidad">
                  <v-stepper-step
                    :key="`${gtiposprocesos[n-1].idtipoproceso}`"
                    
                    :step="gtiposprocesos[n-1].nombrecorto"
                    editable
                  ></v-stepper-step>
                  <v-divider v-if="n !== cantidad" :key="`${n}-divider`"></v-divider>
                </template>
                <v-col cols="4"></v-col>
              </v-row>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content
                v-for="n in cantidad"
                :key="`${n}-content`"
                :step="gtiposprocesos[n-1].nombrecorto"
              >
                <bandeja
                  v-for="i in procesos(gtiposprocesos[n-1])"
                  :key="`${i.idproceso}-content`"
                  :proceso="i.idproceso"
                  :nombre="i.nombre"
                ></bandeja>
              </v-stepper-content>
            </v-stepper-items>
          </template>
        </v-stepper>
      </v-tab-item>
      <v-tab-item>
        
        <v-stepper v-model="tipoproceso" editable non-linear class="mt-12">
          <template>
            Seleccione el instrumento de planeación para revisar las tareas gestionadas
            <v-stepper-header>
              <v-row>
                <v-col cols="4"></v-col>
                <template v-for="n in cantidad">
                  <v-stepper-step
                    :key="`${gtiposprocesos[n-1].idtipoproceso}`"
                    
                    :step="gtiposprocesos[n-1].nombrecorto"
                    editable
                  ></v-stepper-step>
                  <v-divider v-if="n !== cantidad" :key="`${n}-divider`"></v-divider>
                </template>
                <v-col cols="4"></v-col>
              </v-row>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content
                v-for="n in cantidad"
                :key="`${n}-content`"
                :step="gtiposprocesos[n-1].nombrecorto"
              >
              
                <bandejaseguimiento
                  v-for="i in procesos(gtiposprocesos[n-1])"
                  :key="`${i.idproceso}-content`"
                  :proceso="i.idproceso"
                  :nombre="i.nombre"
                ></bandejaseguimiento>
              </v-stepper-content>
            </v-stepper-items>
          </template>
        </v-stepper>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import bandeja from "@/components/content/bandeja.vue";
import bandejaseguimiento from "@/components/content/bandejaseguimiento.vue";
import store from "../../stores/index.js";
export default {
  name: "tareas",
  data() {
    return {
      tipoproceso: "PMI",
      tabactual: 0,
      currentUser : [],
      soloFichaTecnica: false, // variable quemada
    };
  },
  components: {
    bandeja,
    bandejaseguimiento,
  },
  methods: {
    ...mapActions([
      "get_tareas",
      "get_tareasgestionadas",
      "get_configuraciones",
      "get_procesos",
      "get_tiposproceso",
    ]),
    procesos(tipoproceso) {
      let bandejas = this.gprocesos.filter((p) => p.idtipoproceso === tipoproceso.idtipoproceso && p.visible === true);
      if (this.soloFichaTecnica)
        bandejas = bandejas.filter((p) => p.idproceso === 1);
      // se quema esta linea de codigo a solicitud del Arquitecto Marcos Sanchez con la salvedad de que se va a establecer tiempo para cambiarla y ajustar el codigo 
      return bandejas;
    },

    
    usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
  },
  computed: {
    ...mapGetters(["gtiposprocesos", "gprocesos"]),
    cantidad() {
      return this.gtiposprocesos.length;
    },
  },
  mounted() {
    let activo = undefined;
    if (this.gtiposprocesos.length > 0)
      activo = this.gtiposprocesos.filter(
      (p) => p.sigla === this.tipoproceso
    )[0];
    if (activo === undefined) {
      if (this.gtiposprocesos.count > 0) {
        this.tipoproceso = this.gtiposprocesos[0].sigla;
      } else {
        store.watch(
          () => store.getters["gtiposprocesos"],
          () => {
            this.tipoproceso = this.gtiposprocesos[0].sigla;
          }
        );
      }
    }
  },
  created() {
    this.currentUser = this.usuario().usuarioRol;
    this.currentUser.forEach((element) => {
        if (element.nombreRol == 'DT' || element.nombreRol == 'SDHP'){
          this.soloFichaTecnica =  true;
        }
      });    
    this.get_tiposproceso();
    this.get_procesos();
    this.get_configuraciones();
    this.get_tareas();
    this.get_tareasgestionadas();
    let sfiltro = localStorage.filtrotareas;
    if (sfiltro !== undefined) {
      let filtrogeneral = JSON.parse(unescape(sfiltro));
      this.tipoproceso = filtrogeneral.tipoproceso;
      this.tabactual = filtrogeneral.tabactual;
    }
  },
  watch: {
    tabactual() {
      let filtrogeneral = {
        tabactual: this.tabactual,
        tipoproceso: this.tipoproceso,
      };
      localStorage.setItem("filtrotareas", JSON.stringify(filtrogeneral));
    },
    tipoproceso() {
      let filtrogeneral = {
        tabactual: this.tabactual,
        tipoproceso: this.tipoproceso,
      };
      localStorage.setItem("filtrotareas", JSON.stringify(filtrogeneral));
    },
  },
};
</script>
